<!-- 人才管理 -->
<template>
  <div class="talents_manage">
    <div class="empty" v-if="or_empty">
      <img src="@/assets/images/noRencai.png" alt="">
      <p>您还未有心仪的人才哦！</p>
      <Button type="warning" @click="go_talents_list">前去寻找</Button>
    </div>

    <div class="list" v-else>

      <header class="inp">
        <Button type="warning" size="large" @click="search">搜索</Button>
        <Input v-model="obj.name" @on-enter="search" size="large" prefix="ios-search" placeholder="输入关键词，搜索相关人才">
        </Input>
      </header>

      <article>
        <div class="tabs">
          <Button :type="obj.status?'text':'warning'" size="small" @click="get_list('')">全部</Button>
          <Button style="margin-left:20px" :type="obj.status==150?'warning':'text'" size="small" @click="get_list(150)">收藏的人才</Button>
        </div>
      </article>

      <section>
        <div class="list">
          <Spin size="large" fix v-if="spinShow"></Spin>
          <ul>
            <li v-for="(item,index) in talented_list" :key="item._id">

              <Row>
                <Col span="2" style="text-align:center">
                <img :src="item.personalImage?item.personalImage:item.icon" alt="">
                </Col>
                <Col span="20" style="padding-left:10px">
                <p style="color:#000;">{{item.name}}</p>
                <p style="margin:15px 0;color:#000;">
                  <span>{{jsGetAge(item.birthDate)}}岁丨</span>

                  <span>{{item.education}}</span>
                  <span style="margin-left:20px">
                    <Icon type="ios-call" color="#f90" size="20" />
                  </span>
                  <span>{{item.phone}}</span>
                </p>
                <p>
                  <span v-if="item.workArea">
                    期望：
                    {{item.workArea[0]}}-{{item.workArea[1]}}-{{item.workArea[2]}}
                  </span>
                </p>
                </Col>
                <Col span="2">
                <Button type="warning" long @click="$router.push({name:'talents_details',query:{id:item.userId}})">前去查看</Button>
                </Col>
              </Row>

            </li>
          </ul>
        </div>
      </section>

      <footer v-show="this.talented_list.length > 5">
        <Button type="warning" @click="next">下一页</Button>
      </footer>

    </div>

  </div>

</template>

<script>
export default {
  data() {
    return {
      spinShow: false,
      or_empty: false,
      obj: {
        status: '',
        name: "",
        isCount: false,
        page: 1,
        size: 10
      },
      talented_list: []
    }
  },
  methods: {
    //搜索
    search() {
      this.get_data()
    },
    //切换全部or收藏
    get_list(val) {
      this.obj.status = val
      this.obj.page = 1
      this.get_data()
    },
    //跳转寻找人才
    go_talents_list() {
      this.$router.push({ name: 'talents_list' })
      this.$emit("setTitle", "人才列表")
    },
    //下一页
    next() {
      this.obj.page++
      this.get_data()
      document.getElementsByClassName("ivu-layout")[1].scrollTop = 0

    },
    //封装出生年月转换年龄
    jsGetAge(strBirthday) {
      var returnAge;
      if (!strBirthday) {
        return returnAge = '';

      }
      var strBirthdayArr = strBirthday.split("-");

      var birthYear = strBirthdayArr[0];
      var birthMonth = strBirthdayArr[1];
      var birthDay = strBirthdayArr[2];

      var d = new Date();
      var nowYear = d.getFullYear();
      var nowMonth = d.getMonth() + 1;
      var nowDay = d.getDate();
      if (nowYear == birthYear) {
        returnAge = 0;//同年 则为0岁
      }
      else {
        var ageDiff = nowYear - birthYear; //年之差

        if (ageDiff > 0) {
          if (nowMonth == birthMonth) {
            var dayDiff = nowDay - birthDay;//日之差
            if (dayDiff < 0) {
              returnAge = ageDiff - 1;
            }
            else {
              returnAge = ageDiff;
            }
          }
          else {
            var monthDiff = nowMonth - birthMonth;//月之差
            if (monthDiff < 0) {
              returnAge = ageDiff - 1;
            }
            else {
              returnAge = ageDiff;
            }
          }
        }
        else {
          returnAge = '';//返回-1 表示出生日期输入错误 晚于今天
        }
      }
      return returnAge;//返回周岁年龄
    },
    //封装获取数据
    get_data() {
      this.spinShow = true
      this.obj.enterpriseId = localStorage.getItem('firm_enterpriseId')
      this.app("enterpriseOperators", "talentedPeopleList", this.obj).then(res => {
        this.spinShow = false
        console.log("人才管理:", res);

        this.talented_list = res.data


        this.talented_list.forEach((item, index) => {
          //头像存在转换在线头像图片
          if (item.personalImage) {
            item.personalImage = this.img_url(item.personalImage)
          } else {
            //否则生成随机头像
            if (item.sex == 1) {
              let num = Math.ceil(Math.random() * 1000000000 % 9);
              if (num == 1 || num == 2 || num == 3) {
                item.icon = require(`@/assets/images/man_1.png`)
              } else if (num == 4 || num == 5 || num == 6) {
                item.icon = require(`@/assets/images/man_2.png`)
              } else {
                item.icon = require(`@/assets/images/man_3.png`)
              }
            } else {
              let num = Math.ceil(Math.random() * 1000000000 % 9);
              if (num == 1 || num == 2 || num == 3) {
                item.icon = require(`@/assets/images/women_1.png`)
              } else if (num == 4 || num == 5 || num == 6) {
                item.icon = require(`@/assets/images/women_2.png`)
              } else {
                item.icon = require(`@/assets/images/women_3.png`)
              }
            }
          }
        })
        if (!this.obj.status && !this.talented_list.length) {
          this.or_empty = true
        }
        if (this.obj.status && !this.talented_list.length) {
          this.$Modal.warning({
            title: '暂无收藏的人才',
            closable: true
          })
        }

      })
    },
  },
  created() {
    this.get_data()

  }
}
</script>

<style lang="less" scoped>
@import "./talents_manage.less";
</style>
